import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    "en": '',
  },
});

function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync (lang) {
  i18n.setLocaleMessage(lang, languages[lang]);
  return setI18nLanguage(lang);
}

const languages = {
  'en': {
    "Filter results": "Filter results by title, keyword, or acronym",
    "Name": "Name",
    "Description": "Description",
    "Connect": "Connect",
  },
  'es': {
    "Filter results": "Filtrar los resultados por título, palabra clave o acrónimo",
    "Name": "Nombre",
    "Description": "Descripción",
    "Connect": "Conectar",
  },
  'zh': {
    "Filter results": "按标题、关键字或首字母缩略词筛选结果",
    "Name": "姓名",
    "Description": "描述",
    "Connect": "连接",
  },
  'ar': {
    "Filter results": "تصفية النتائج حسب العنوان أو الكلمة الرئيسية أو الاختصار",
    "Name": "الاسم",
    "Description": "الوصف",
    "Connect": "تواصل معنا",
  },
  'ht': {
    "Filter results": "Filtre rezilta pa tit, mo kle, oswa akwonim",
    "Name": "Non",
    "Description": "Deskripsyon",
    "Connect": "Konekte",
  },
  'fr': {
    "Filter results": "Filtrer les résultats par titre, mot clé ou acronyme",
    "Name": "Nom",
    "Description": "Descriptif",
    "Connect": "Connectez",
  },
  'sw': {
    "Filter results": "Chuja matokeo kwa kichwa, neno kuu, au kifupi",
    "Name": "Jina",
    "Description": "Maelezo",
    "Connect": "Unganisha",
  },
  'pt': {
    "Filter results": "Filtrar resultados por título, palavra-chave ou acrônimo",
    "Name": "Nome",
    "Description": "Descrição",
    "Connect": "Conectar",
  },
  'ru': {
    "Filter results": "Фильтруйте результаты по заголовку, ключевому слову или аббревиатуре",
    "Name": "Имя",
    "Description": "Описание",
    "Connect": "Подключить",
  },
  'vi': {
    "Filter results": "Lọc kết quả theo tiêu đề, từ khóa hoặc từ viết tắt",
    "Name": "Tên",
    "Description": "Mô tả",
    "Connect": "Kết nối",
  },
};
